import { z } from "zod";

export const contactFormSchema = z.object({
  name: z.string().min(1, { message: "Enter your name" }),
  email: z.string().email({ message: "Enter a valid email address" }),
  homepage: z.string().min(1, {
    message: "Add your company website",
  }),
  message: z.string().min(1, { message: "Include your message" }),
  referrer: z.string().optional(),
});

export type ContactFormInput = z.infer<typeof contactFormSchema>;
